import {Component, OnInit, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';

import {CadastrarProfissionaisComponent} from '../cadastrar-profissionais/cadastrar-profissionais.component';
import {ModalService} from 'src/app/shared/services/modal.service';
import {IProfessionalState} from 'src/app/store/professional/professional.reducer';
import {
  selectProfessionalLista,
  selectProfessionalState
} from 'src/app/store/professional/professional.selectors';
import {deleteProfessional, editProfessional, loadProfessional} from 'src/app/store/professional/professional.actions';
import {IProfessional} from 'src/app/shared/interfaces/professional/iprofessional';
import {ProfessionalFilter, ProfessionalService} from 'src/app/shared/services/professional.service';
import {FilterModel} from 'src/app/shared/components/split-button-filter/split-button-filter.component';
import {selectUnitActiveList} from 'src/app/store/unidade/unidade.selectors';
import {ProfessionService} from 'src/app/shared/services/profession.service';
import {NotifyService} from 'src/app/shared/services/notify.service';
import {Filter} from 'src/app/shared/models/filter';
import {SplitTableComponent} from "../../../../shared/components/split-table/split-table.component";

@Component({
  selector: 'app-lista-profissionais',
  templateUrl: './lista-profissionais.component.html',
  styleUrls: ['./lista-profissionais.component.scss'],

  providers: [DialogService],
})
export class ListaProfissionaisComponent implements OnInit {
  mostrarModalExcluir: boolean = false;
  mostrarModalInativar: boolean = false;
  mostrarModalAtivar: boolean = false;
  isLoading: boolean = true;
  filters: Array<any> = [];
  filter = new ProfessionalFilter();
  listaUnidades$ = this.store.select(selectUnitActiveList);
  professionalList!: any[]
  condicionalData = [
    {name: 'Sim', id: 1},
    {name: 'Não', id: 0}
  ];

  public currentIndex: any;

  readonly ID_UNIT_FILTER = 'unit';
  readonly ID_PROFESSION_FILTER = 'profession';

  protected filterParams: Filter = new Filter().filter('isActive', true);
  protected listActive = [
    {name: 'Ativo', id: true},
    {name: 'Inativo', id: false}
  ];

  @ViewChild("idTable") protected tableRef!: SplitTableComponent;

  professionalState$ = this.store.select(selectProfessionalState)
  listaProfissionais$ = this.store.select(selectProfessionalLista)

  ref: DynamicDialogRef | undefined;
  totalItems: number = 0;

  constructor(
    public dialogService: DialogService,
    private modalService: ModalService,
    private store: Store<IProfessionalState>,
    private professionalService: ProfessionalService,
    private professionService: ProfessionService
  ) {
    this.professionalService.setFilter(new ProfessionalFilter());
  }

  ngOnInit(): void {
    this.loadUnitFilter();
    this.loadProfessionFilter();

    this.professionalState$.subscribe(res => {
      if (res.action != 'get' && res.type == 'success') {
        this.load();
      }
    })

    this.load();
  }

  ngOnDestroy(): void {
    this.professionalService.clearFilterQueryParams();
  }

  onPageChange(event: any) {
    this.isLoading = true;

    this.filterParams.filter("page", event.page)
    this.filter.page = event.page;
    this.professionalService.setFilterQueryParams(this.filterParams.convertFilterInQuery());

    this.load();
  }

  loadUnitFilter() {
    this.listaUnidades$.subscribe((result: Array<any>) => {

      let exist = this.filters.find(item => item.id == this.ID_UNIT_FILTER) != undefined;

      if (result.length == 0 || exist) {
        return;
      }
      let data = result.map((item: { id: string, unitName: string }) => {
        return {value: item.unitName, code: item.id}
      });

      this.filters.push({
        id: this.ID_UNIT_FILTER,
        type: "DROPDOWN",
        name: "Unidade",
        data: data
      });
    })
  }

  loadProfessionFilter() {
    this.professionService.getAll().subscribe((result: any) => {
      if (result.length == 0) {
        return;
      }
      let data = result.map((item: { id: string, name: string }) => {
        return {value: item.name, code: item.id}
      });
      this.filters.push({
        id: this.ID_PROFESSION_FILTER,
        type: "DROPDOWN",
        name: "Profissão",
        data: data
      });
    })
  }

  public dialogExcluir(item?: any) {
    this.mostrarModalExcluir = !this.mostrarModalExcluir;
    this.currentIndex = item;
  }

  public dialogInativar(item?: any) {
    this.mostrarModalInativar = !this.mostrarModalInativar;
    this.currentIndex = item;
  }

  public inativarItem() {
    const item: IProfessional = this.currentIndex;
    this.store.dispatch(editProfessional({professional: {isActive: false} as any, id: item.id as any}))

    this.professionalState$.subscribe(res => {

      if (res.action == 'edit') {
        if (res.type == 'success') {
          return this.fecharDialog();
        }

      }
    })
  }

  excluirItem() {
    const item: IProfessional = this.currentIndex;
    this.store.dispatch(deleteProfessional({id: item.id as any}));
    this.dialogExcluir();
  }

  public mostrarCadastro() {
    this.modalService.calledfor('cadastrar');
    this.modalService.show(CadastrarProfissionaisComponent, 'Cadastro do Profissional')
  }

  public editarCadastro(item: any, servico: boolean = false) {
    this.modalService.calledfor('editar');
    this.modalService.show(CadastrarProfissionaisComponent, 'Editar Cadastro do Profissional', {item: item, servico})
  }

  public fecharDialog() {
    this.ref?.destroy();
    this.mostrarModalAtivar = false;
    this.mostrarModalInativar = false;
  }

  mapUnidadeName(units: any[]) {
    return units.map(item => item.unitName)
  }

  formataEspecialidades(specialties: any[]) {
    const nomes = specialties.map(item => item.name)
    return nomes.join(', ')
  }

  ativarItem(item: any) {
    this.currentIndex = item;
    this.mostrarModalAtivar = true
  }

  ativarItemPatch() {
    let item = this.currentIndex
    this.store.dispatch(editProfessional({professional: {isActive: true} as any, id: item.id as any}))

    this.professionalState$.subscribe(res => {

      if (res.action == 'edit') {
        if (res.type == 'success') {
          return this.fecharDialog()
        }

      }
    })
  }

  setProfessionName(iri: string) {
    return this.profissaoLista.filter((res: any) => {
      return res['@id'] == iri
    })[0]?.name
  }

  filterName(name: string) {
    this.isLoading = true;

    this.filterParams.clearFilter('name');
    if (name.length > 0) {
      this.filterParams.filter('name', name);
    }

    this.filterParams.filter('page', '1')
    this.tableRef.setPage(0);

    this.professionalService.setFilterQueryParams(this.filterParams.convertFilterInQuery());

    this.load();
  }

  onFilterChange(event: any) {
    event.forEach((e: any) => {
      this.filterParams.setFilter(e.key, e.filter);
    });

    this.filterParams.filter('page', '1')
    this.tableRef.setPage(0);

    this.professionalService.setFilterQueryParams(this.filterParams.convertFilterInQuery());
    this.load();
  }

  load() {
    this.isLoading = true;
    let filter = this.filterParams.convertFilterInQuery();

    this.professionalService.totalItemsSubject.subscribe(total => this.totalItems = total);
    this.professionalService.getAll(filter, "10").subscribe(
      {
        next: (response: any) => {
          this.professionalList = response;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
  }

  listaUnidades: Array<any> = [
    {
      foto: 'https://www.creativefabrica.com/wp-content/uploads/2022/10/18/Handsome-Mans-Headshot-In-Studio-Lighting-42095282-1.png',
      nome: 'Luiz Carlos Antônio da Silva',
      email: 'luizcarlos@gmail.com',
      telefone: '55 (11) 962052756',
      profissao: 'Médico',
      especialidade: 'Cardiologista',
      unidades: [
        'Inova Saúde',
        'Vila Nova',
        'Coração Eucarístico',
        'Primus Saúde & Diagnóstico',
      ],
    },
    {
      foto: 'https://www.creativefabrica.com/wp-content/uploads/2022/10/18/Handsome-Mans-Headshot-In-Studio-Lighting-42095282-1.png',

      nome: 'Manoela Cardoso',
      email: 'manoelacardoso@gmail.com',
      telefone: '55 (11) 962052756',
      profissao: 'Médico',
      especialidade: 'Cardiologista',
      unidades: [
        'Vila Nova',
        'Coração Eucarístico',
        'Inova Saúde e Medicina',
        'Primus Saúde & Diagnóstico',
      ],
    },
    {
      foto: 'https://www.creativefabrica.com/wp-content/uploads/2022/11/28/Santa-Claus-By-Charlie-Bowater-49142964-1.png',

      nome: 'Alexandre Cordeiro',
      email: 'alexandrecordeiro@gmail.com',
      telefone: '55 (11) 962052756',
      profissao: 'Médico',
      especialidade: 'Cardiologista',
      unidades: [
        'Coração Eucarístico',
        'Vila Nova',
        'Inova Saúde e Medicina',
        'Primus Saúde & Diagnóstico',
      ],
    },
  ];

  profissaoLista: any[] = [
    {
      "@id": "/api/professions/1",
      "@type": "Profession",
      "id": 1,
      "name": "Médico",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRM",
      "exceptionList": [],
      "employees": [
        "/api/employees/89",
        "/api/employees/94",
        "/api/employees/96"
      ]
    },
    {
      "@id": "/api/professions/2",
      "@type": "Profession",
      "id": 2,
      "name": "Dentista",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/3",
      "@type": "Profession",
      "id": 3,
      "name": "Nutricionista",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRN",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/4",
      "@type": "Profession",
      "id": 4,
      "name": "Enfermeiro",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "COREN",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/5",
      "@type": "Profession",
      "id": 5,
      "name": "Fisioterapeuta",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFITO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/6",
      "@type": "Profession",
      "id": 6,
      "name": "Terapeuta Ocupacional",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFITO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/7",
      "@type": "Profession",
      "id": 7,
      "name": "Fonoaudiólogo",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFONO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/8",
      "@type": "Profession",
      "id": 8,
      "name": "Veterinário",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRMV",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/9",
      "@type": "Profession",
      "id": 9,
      "name": "Psicólogo",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRP",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/10",
      "@type": "Profession",
      "id": 10,
      "name": "Outro profissional da saúde",
      "professionCategory": "/api/profession_categories/1",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/11",
      "@type": "Profession",
      "id": 11,
      "name": "Cabeleireiro",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/12",
      "@type": "Profession",
      "id": 12,
      "name": "Esteticista",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/13",
      "@type": "Profession",
      "id": 13,
      "name": "Manicure e Pedicure",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/14",
      "@type": "Profession",
      "id": 14,
      "name": "Maquiador",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/15",
      "@type": "Profession",
      "id": 15,
      "name": "Massoterapeuta",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/16",
      "@type": "Profession",
      "id": 16,
      "name": "Terapeuta Holístico",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/17",
      "@type": "Profession",
      "id": 17,
      "name": "Outro profissional de beleza e bem estar",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    }
  ];
}
